import {view} from '@sail/ui';
import {Text} from 'src/v2/components/common';
import type {PaymentOption} from 'src/v2/state/types';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';

type WalletItemProps = {
  walletOption: PaymentOption;
};

export const WalletItem = ({walletOption}: WalletItemProps) => {
  const {name} = walletOption;

  return (
    <view.div
      css={{
        stack: 'y',
        gap: 'small',
        alignX: 'center',
      }}
    >
      <WalletIcon walletOption={walletOption} />
      <Text
        type="caption"
        css={{
          textAlign: 'center',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 'space.1000',
        }}
      >
        {name}
      </Text>
    </view.div>
  );
};
